// extracted by mini-css-extract-plugin
module.exports = {"modal_block":"DeclineProposalModal_modal_block__2lfKb","footer":"DeclineProposalModal_footer__3sz6l"};